import { formatDate, formatTime } from "./DateFormat";
import { Tag, Dropdown, Space, DatePicker, Button } from "antd";
import { DeleteOutlined, EllipsisOutlined, EyeOutlined, PhoneOutlined } from "@ant-design/icons";
import { qaTypeButtons, roleNames } from "../constant";
import DateRangeFilter from "../components/filters/DateRangeFilter";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

export const ShowData = (item, role = null, index) => {
  return {
    id: item.id,
    key: item.id,
    "Call ID": item.id || null,
    "Call date": formatDate(item?.start_time),
    "Start time": formatTime(item?.start_time),
    "End time": formatTime(item?.end_time),
    "Agency name": item.site || null,
    Circle: item.circle || null,
    "Call duration":
      typeof item?.call_time === "string" && item?.call_time.includes(":")
        ? item.call_time
        : item?.call_time
        ? `${Math.round(Number(item.call_time) / 60)} min`
        : item?.duration
        ? `${Math.round(Number(item.duration) / 60)} min`
        : null,
    "Call type": item.call_type || null,
    "Agent ID": item.agent_id || null,
    "Disconnected by": item.disconnect_by || null,
    Disposition: item.disposition_name || null,
    "Call status":
      role == roleNames.qa ? item.call_status : item.connected ? "Connected" : "Disconnected",
    "Customer phone number": item.phone_number || null,
    assigned_users: item.assigned_users || [],
    originalItem: item,
    assigned_users_text: Array.isArray(item.assigned_users)
      ? item.assigned_users
          ?.map((u) => `${u.name} - (${u.audit_types?.map((a) => a.audit_type_name).join(", ")})`)
          .join(", ") || "-"
      : `${item.assigned_users?.name} - (${item.assigned_users?.audit_types
          ?.map((a) => a.audit_type_name)
          .join(", ")})`,
  };
};

export const getCallTableColumns = (viewCallback) => [
  {
    title: "Call ID",
    dataIndex: "Call ID",
    key: "Call ID",
    width: 100,
  },
  {
    title: "Call date",
    dataIndex: "Call date",
    key: "Call date",
    width: 134,
    filterDropdown: (props) => <DateRangeFilter {...props} />,
    onFilter: (value, record) => {
      if (!value || value.length !== 2) return true;

      const [start, end] = value;
      const recordDate = dayjs(record["Call date"]);

      return recordDate.valueOf() >= start.valueOf() && recordDate.valueOf() <= end.valueOf();
    },
  },
  {
    title: "Start time",
    dataIndex: "Start time",
    key: "Start time",
    width: 134,
  },
  {
    title: "End time",
    dataIndex: "End time",
    key: "End time",
    width: 134,
  },
  {
    title: "Agency name",
    dataIndex: "Agency name",
    key: "Agency name",
    width: 134,
  },
  {
    title: "Circle",
    dataIndex: "Circle",
    key: "Circle",
    width: 134,
  },
  {
    title: "Call duration",
    dataIndex: "Call duration",
    key: "Call duration",
  },
  {
    title: "Call type",
    dataIndex: "Call type",
    key: "Call type",
    width: 134,
    filters: [
      { text: "Outgoing", value: "Outgoing" },
      { text: "Incoming", value: "Incoming" },
    ],
    onFilter: (value, record) => value && record["Call type"] === value,
  },
  {
    title: "Agent ID",
    dataIndex: "Agent ID",
    key: "Agent ID",
    width: 134,
  },
  {
    title: "Disconnected by",
    dataIndex: "Disconnected by",
    key: "Disconnected by",
    filters: [
      { text: "Customer", value: "CUSTOMER" },
      { text: "Agent", value: "AGENT" },
    ],
    onFilter: (value, record) => value && record["Disconnected by"] === value,
  },
  {
    title: "Disposition",
    dataIndex: "Disposition",
    key: "Disposition",
    width: 350,
  },
  {
    title: "Call status",
    dataIndex: "assigned_users",
    key: "Call status",
    render: (assigned_users) => {
      const auditTypes = assigned_users?.audit_types || [];
      const allReviewed =
        auditTypes.length > 0 && auditTypes.every((audit) => audit.status === true);
      const statusText = allReviewed ? "Reviewed" : "Assigned";
      const tagColor = allReviewed ? "green" : "orange";

      return <Tag color={tagColor}>{statusText}</Tag>;
    },
    filters: [
      { text: "Assigned", value: "Assigned" },
      { text: "Reviewed", value: "Reviewed" },
    ],
    onFilter: (value, record) => {
      const auditTypes = record?.assigned_users?.audit_types || [];
      const allReviewed =
        auditTypes.length > 0 && auditTypes.every((audit) => audit.status === true);
      const statusText = allReviewed ? "Reviewed" : "Assigned";
      return statusText === value;
    },
  },

  {
    title: "Customer phone number",
    dataIndex: "Customer phone number",
    key: "Customer phone number",
  },
  {
    title: "Action",
    key: "Action",
    render: (_, record) => {
      const qaMenuItems = [
        {
          key: "1",
          label: "View details",
          icon: <EyeOutlined />,
          onClick: () => {
            viewCallback(record);
          },
        },
      ];

      return (
        <Dropdown menu={{ items: qaMenuItems }} trigger={["click"]}>
          <a onClick={(e) => e.preventDefault()}>
            <Space>
              <EllipsisOutlined style={{ fontSize: 20 }} />
            </Space>
          </a>
        </Dropdown>
      );
    },
  },
];

export const getAssignTableColumns = (viewCallback, handleDeleteCall) => [
  {
    title: "Call type",
    dataIndex: "Call type",
    key: "Call type",
    width: 134,

    filters: [
      { text: "Outgoing", value: "Outgoing" },
      { text: "Incoming", value: "Incoming" },
    ],
    onFilter: (value, record) => value && record["Call type"] === value,
  },
  {
    title: "Call duration",
    dataIndex: "Call duration",
    key: "Call duration",
  },
  {
    title: "Call date",
    dataIndex: "Call date",
    key: "Call date",
    width: 134,
    filterDropdown: (props) => <DateRangeFilter {...props} />,
    onFilter: (value, record) => {
      if (!value || value.length !== 2) return true;

      const [start, end] = value;
      const recordDate = dayjs(record["Call date"]);

      return recordDate.valueOf() >= start.valueOf() && recordDate.valueOf() <= end.valueOf();
    },
  },
  {
    title: "Agent ID",
    dataIndex: "Agent ID",
    key: "Agent ID",
    width: 134,
  },
  {
    title: "Agency name",
    dataIndex: "Agency name",
    key: "Agency name",
    width: 134,
  },
  {
    title: "Call status",
    dataIndex: "Call status",
    key: "Call status",
    render: (status) => <Tag color={status === "Connected" ? "green" : "red"}>{status}</Tag>,
    filters: [
      { text: "Connected", value: "Connected" },
      { text: "Disconnected", value: "Disconnected" },
    ],
    onFilter: (value, record) => record["Call status"] === value,
  },
  {
    title: "Call ID",
    dataIndex: "Call ID",
    key: "Call ID",
    width: 100,
  },
  {
    title: "Disconnected by",
    dataIndex: "Disconnected by",
    key: "Disconnected by",
    filters: [
      { text: "Customer", value: "CUSTOMER" },
      { text: "Agent", value: "AGENT" },
    ],
    onFilter: (value, record) => value && record["Disconnected by"] === value,
  },
  {
    title: "Disposition",
    dataIndex: "Disposition",
    key: "Disposition",
    width: 350,
  },
  {
    title: "Customer phone number",
    dataIndex: "Customer phone number",
    key: "Customer phone number",
  },
  {
    title: "Action",
    key: "Action",
    render: (_, record) => {
      const menuItems = [
        {
          key: "1",
          label: "View Details",
          icon: <EyeOutlined />,
          onClick: () => {
            viewCallback(record);
          },
        },
        {
          key: "2",
          label: "Delete Call",
          icon: <DeleteOutlined />,
          onClick: () => handleDeleteCall(record),
        },
      ];
      return (
        <Dropdown menu={{ items: menuItems }} trigger={["click"]}>
          <a onClick={(e) => e.preventDefault()}>
            <Space>
              <EllipsisOutlined style={{ fontSize: 20 }} />
            </Space>
          </a>
        </Dropdown>
      );
    },
  },
];

export const getManageQaTableColumns = (showLoading, setModelType, handleEditUser) => [
  {
    title: "Name",
    dataIndex: "Name",
    key: "Name",
  },
  {
    title: "Email",
    dataIndex: "Email",
    key: "Email",
  },
  {
    title: "Phone Number",
    dataIndex: "mobile_number",
    key: "mobile_number",
  },
  {
    title: "User Name",
    dataIndex: "username",
    key: "username",
  },
  {
    title: "Created",
    dataIndex: "created_at",
    key: "created_at",
  },
  {
    title: "Updated",
    dataIndex: "updated_at",
    key: "updated_at",
  },
  {
    title: "Status",
    dataIndex: "Status",
    key: "Status",
    render: (status) => <Tag color={status === "Connected" ? "green" : "red"}>{status}</Tag>,
  },
  {
    title: "Action",
    key: "Action",
    render: (_, record) => {
      const menuItems = [
        {
          key: "1",
          label: "Edit user",
          icon: <EyeOutlined />,
          onClick: () => {
            setModelType("edit");
            showLoading(record.originalItem);
          },
        },
        {
          key: "2",
          label: "Delete user",
          icon: <DeleteOutlined />,
          onClick: () => handleEditUser(record),
        },
      ];
      return (
        <Dropdown menu={{ items: menuItems }} trigger={["click"]}>
          <a onClick={(e) => e.preventDefault()}>
            <Space>
              <EllipsisOutlined style={{ fontSize: 20 }} />
            </Space>
          </a>
        </Dropdown>
      );
    },
  },
];

export const getAssignedQAColumns = (role, setIsAudit, handleAuditCall, handleView) =>
  [
    {
      title: "Call ID",
      dataIndex: "Call ID",
      key: "Call ID",
      width: 100,
    },
    {
      title: "Call date",
      dataIndex: "Call date",
      key: "Call date",
      width: 134,
      filterDropdown: (props) => <DateRangeFilter {...props} />,
      onFilter: (value, record) => {
        if (!value || value.length !== 2) return true;

        const [start, end] = value;
        const recordDate = dayjs(record["Call date"]);

        return recordDate.valueOf() >= start.valueOf() && recordDate.valueOf() <= end.valueOf();
      },
    },
    {
      title: "Start time",
      dataIndex: "Start time",
      key: "Start time",
      width: 134,
    },
    {
      title: "End time",
      dataIndex: "End time",
      key: "End time",
      width: 134,
    },
    {
      title: "Agency name",
      dataIndex: "Agency name",
      key: "Agency name",
      width: 134,
    },
    {
      title: "Call duration",
      dataIndex: "Call duration",
      key: "Call duration",
    },
    {
      title: "Call type",
      dataIndex: "Call type",
      key: "Call type",
      width: 134,

      filters: [
        { text: "Outgoing", value: "Outgoing" },
        { text: "Incoming", value: "Incoming" },
      ],
      onFilter: (value, record) => value && record["Call type"] === value,
    },
    {
      title: "Agent ID",
      dataIndex: "Agent ID",
      key: "Agent ID",
      width: 134,
    },
    {
      title: "Disconnected by",
      dataIndex: "Disconnected by",
      key: "Disconnected by",
      filters: [
        { text: "Customer", value: "CUSTOMER" },
        { text: "Agent", value: "AGENT" },
      ],
      onFilter: (value, record) => value && record["Disconnected by"] === value,
    },
    {
      title: "Disposition",
      dataIndex: "Disposition",
      key: "Disposition",
      width: 350,
    },
    role !== roleNames.qa && {
      title: "Assigned QA",
      key: "assigned_users",
      render: (_, record) => {
        const users = record.assigned_users;
        return users && users.length > 0 ? (
          users.map((user) => (
            <Tag key={user.id} color="geekblue">
              {user.name} - ({user?.audit_types?.map((item) => item?.audit_type_name).join(", ")})
            </Tag>
          ))
        ) : (
          <span>-</span>
        );
      },
    },
    {
      dataIndex: "assigned_users_text",
      key: "assigned_users_text",
      hidden: true,
    },
    {
      title: "Call status",
      dataIndex: "Call status",
      key: "Call status",
      render: (status) => <Tag color={status === "Connected" ? "green" : "red"}>{status}</Tag>,
      filters: [
        { text: "Connected", value: "Connected" },
        { text: "Disconnected", value: "Disconnected" },
      ],
      onFilter: (value, record) => record["Call status"] === value,
    },
    {
      title: "Customer phone number",
      dataIndex: "Customer phone number",
      key: "Customer phone number",
    },
    role === roleNames.qa && {
      title: "Audit Types",
      key: "assigned_users",
      render: (_, record) => {
        const auditTypes =
          record?.originalItem?.assigned_users?.audit_types?.filter(
            (item) => item?.status === false
          ) || [];

        return auditTypes && auditTypes.length > 0 ? (
          auditTypes.map((user) => (
            <Tag key={user.audit_type_id} color="geekblue">
              {user.audit_type_name}
            </Tag>
          ))
        ) : (
          <span>-</span>
        );
      },
      filters: qaTypeButtons.map((item) => ({ text: item.label, value: item.id })),
      onFilter: (value, record) =>
        record?.originalItem?.assigned_users?.audit_types
          ?.filter((item) => item?.status === false)
          ?.some((item) => item?.audit_type_id === value),
    },
    {
      title: "Action",
      key: "Action",
      render: (record) => {
        const auditTypeOptions =
          record?.originalItem?.assigned_users?.audit_types
            ?.filter((item) => item?.status === false)
            ?.map((item) => ({
              label: item?.audit_type_name,
              value: item?.audit_type_id,
            })) || [];

        const menuItems = [
          ((role === roleNames.qa && auditTypeOptions?.length) ||
            role === roleNames.superAdmin) && {
            key: "1",
            label: role === roleNames.qa ? "Audit Calls" : "View details",
            icon: role === roleNames.qa ? <PhoneOutlined /> : <EyeOutlined />,
            onClick: () => {
              if (role === roleNames.qa) {
                setIsAudit(true);
                handleAuditCall(record);
              } else {
                handleView(record);
              }
            },
          },
          role === roleNames.qa && {
            key: "2",
            label: "Call Details",
            icon: <EyeOutlined />,
            onClick: () => {
              handleView(record);
            },
          },
        ];

        return (
          <Dropdown
            menu={{
              items: menuItems,
            }}
            trigger={["click"]}
          >
            <a onClick={(e) => e.preventDefault()}>
              <Space>
                <EllipsisOutlined style={{ fontSize: 20 }} />
              </Space>
            </a>
          </Dropdown>
        );
      },
    },
  ].filter(Boolean);
